import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Add language detection options
      order: ["localStorage", "cookie", "navigator"],
      lookupLocalStorage: "i18nextLng",
      lookupCookie: "i18next",
      caches: ["localStorage", "cookie"],
      // Force "en" instead of "en-US"
      convertDetectedLanguage: (lng) => lng.split("-")[0],
    },
    resources: {
      en: {
        translation: require("@lib/i18n/locales/en.json"),
      },
      nl: {
        translation: require("@lib/i18n/locales/nl.json"),
      },
    },
  });

export default i18n;
